import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ResearchCards from '../components/ResearchCards';

const Research: React.FC = () => {
  return (
    <div style={{ background: '#F5F9FA', minHeight: '100vh' }}>
      <Header />
      <main>
        <div className="author-info">
          <h2 className="name-title" style={{ fontSize: '3em', fontWeight: 'normal', marginBottom: '0.2em' }}>Research Projects</h2>
          <div className="author-description" style={{ fontSize: '1em' }}>
            Research in AI and its applications to healthcare, social studies and neuroscience.
          </div>
        </div>
        <ResearchCards />
      </main>
      <hr style={{ border: 'none', borderTop: '1px solid #ccc' }} />
      <Footer />
    </div>
  );
};

export default Research;
